import { Inject } from '@odinjs/odin';
import { UserCardAPI } from '@philips-emr/referring-physician-components';
import Controller, { OnClick, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { ButtonAPI, FieldAPI } from '@philips-internal/oswald-ui-components';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { MountEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { APPLICATION_ROUTES } from '../../constants/application-routes';
import BaseController from '../BaseController';

import { applicationContext } from '@philips-internal/oswald-ui-foundation';

interface Users {
  nrSequence: string;
  nmPhysicalPerson: string;
  dsLogin: string;
  situationDesc: string;
  type: string;
  situation: string;
  dtAtivacao: string;
}

@Controller({ fragment: 'new-user-by-login', component: 'layout-users' })
export default class NewUserByLoginController extends BaseController {

  @Inject('button-new-user')
  button: ButtonAPI;

  @Inject('user-field')
  userField: FieldAPI;

  @OnMount({ target: 'user-card-0' })
  onCdUser(event: MountEvent): void {
    const user = event.target as unknown as UserCardAPI;
    user.onClickCard.listen((c)=> {this.onClickUserCard(c.value)});
  }

  @OnMount({ target: 'button-new-user' })
  buttonName(): void {
    this.button.setValue(MessageService.translate('results.new-user-button').toUpperCase());
  }

  @OnClick({ target: ['button-new-user'] })
  onClick(): void {
    this.historyService.push(APPLICATION_ROUTES.NEW_USER_BY_LOGIN);
  }

  onClickUserCard(user: Users): void {
    const params = {
      nrSequence: user.nrSequence,
      nmPhysicalPerson: user.nmPhysicalPerson,
      dsLogin: user.dsLogin,
      situationDesc: user.situationDesc,
      type: user.type,
      situation: user.situation,
      ativado: user.dtAtivacao === 'true' ? 1 : 0,
    }
    applicationContext.redirect(APPLICATION_ROUTES.USER_PROFILE,{},{searchParams: params});
  }

}
